import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";

// Simple in-memory cache to prevent fetching the same image SEO multiple times
const seoImageCache = {};

export default function SeoImage({ src, alt: defaultAlt, caption: defaultCaption, className, ...props }) {
  const [altText, setAltText] = useState(defaultAlt || "Image");
  const [caption, setCaption] = useState(defaultCaption || "");

  useEffect(() => {
    if (!src) return;

    // Check cache first
    if (seoImageCache[src]) {
      setAltText(seoImageCache[src].alt_text);
      if (seoImageCache[src].caption) {
        setCaption(seoImageCache[src].caption);
      }
      return;
    }

    // Fetch from backend
    const fetchSeo = async () => {
      try {
        const res = await axios.get(`${API}/seo/images/check`, {
          params: { url: src }
        });
        
        if (res.data?.alt_text) {
          setAltText(res.data.alt_text);
          if (res.data.caption) {
            setCaption(res.data.caption);
          }
          // Save to cache
          seoImageCache[src] = {
            alt_text: res.data.alt_text,
            caption: res.data.caption
          };
        }
      } catch (err) {
        // Silently fail and use default alt
      }
    };

    fetchSeo();
  }, [src, defaultAlt, defaultCaption]);

  return (
    <div className={`relative inline-block w-full h-full`}>
      <img
        src={src}
        alt={altText}
        title={caption || altText} // Title acts as a tooltip and helps SEO
        className={className}
        {...props}
      />
    </div>
  );
}
